export default "__VITE_ASSET__D9p2KX_G__"